import { useServiceScheduleContext } from '../../../context/serviceScheduleContext'
import { formatPrice, getPetPhotoByType } from 'utils'

import * as S from './styles'
import CheckIcon from 'static/icons/check-discount-icon.svg'

const SchedulingInfo = ({ finalStep }) => {
  const {
    state: schedulingState,
    functions
  } = useServiceScheduleContext()

  const {
    pricesInfo
  } = functions

  const {
    activeCampaign,
    schedulingCoupon,
    petsData,
    scheduleBody,
    serviceData
  } = schedulingState

  const {
    currentSchedulePrice,
    currentPriceWithDiscount,
    currentHasDiscount
  } = pricesInfo()

  const showDiscount = scheduleBody.selectDay && currentHasDiscount
  const petToRender = petsData.find(pet => pet.id === scheduleBody.pet_id)
  const selectedService = serviceData.find(service => service.value === scheduleBody?.service_id)
  const formattedDiscount = () => {
    const discountType = schedulingCoupon?.discountType || activeCampaign?.discountType
    const discountValue = schedulingCoupon?.discountValue ?? activeCampaign?.discountValue
    return discountType === 'PERCENTAGE' ? `${discountValue}% OFF` : `${formatPrice(discountValue)} OFF`
  }

  return (
    <S.CardContainer>
      <S.StickyCard active>
        <S.Summary title={`Agendamento de ${petToRender?.name}`}>
          <div>
            <S.PhotoContainer
              src={petToRender?.photo || getPetPhotoByType(petToRender?.breed?.type)}
              alt={petToRender?.name}
              setDefaultPhoto={!petToRender?.photo}
            />
            <section className='pet-info'>
              <p className='pet-name'>{petToRender?.name}</p>
              <p className='service-name'>{selectedService?.name}</p>
            </section>
          </div>
          {!!scheduleBody.partner_id && (
            <section className='price'>
              {(!finalStep && currentSchedulePrice > 0) &&
                <S.Price previousPrice={showDiscount} price>{formatPrice(currentSchedulePrice)}</S.Price>}
              {(!finalStep && showDiscount) && (
                <S.Price price>
                  {formatPrice(currentPriceWithDiscount)}
                </S.Price>
              )}
            </section>
          )}

        </S.Summary>
        {(!finalStep && showDiscount) && (
          <S.DiscountAmount>
            <CheckIcon />
            {`Desconto aplicado ${formattedDiscount()}`}
          </S.DiscountAmount>
        )}
      </S.StickyCard>
    </S.CardContainer>
  )
}

export default SchedulingInfo
